import { Typography, useTheme, Box, Grid, Stack, alpha } from '@mui/material';

// Components
import { IContributeDetailReportWrong } from 'src/utils/typings/response/contribute';
import { renderTextOrDefault } from 'src/utils/helpers/stringHelpers';
import { getArrayDefault } from 'src/utils/helpers/arrayHelpers';
import { ChevronDown, ChevronsRight } from 'react-feather';
import IconFeather from 'src/components/common/Icon';

const ReportWrongOtherContact = ({ dataContribution }: { dataContribution: IContributeDetailReportWrong }) => {
  const theme = useTheme();

  return (
    <Box
      width="100%"
      padding={2}
      border={`1px dashed ${theme.palette.divider}`}
      borderRadius={theme.shape.borderRadius / 2}
    >
      <Stack
        direction="row"
        spacing={1}
        divider={
          <IconFeather
            icon={<ChevronsRight />}
            muiProps={{
              fontSize: 'medium',
              sx: { color: 'transparent' },
            }}
          />
        }
      >
        <Box width="100%">
          <Typography variant="subtitle1" align="left">
            Old Data
          </Typography>
          <Box mt={1} />
          <Typography variant="body2" align="left" color="text.secondary">
            Information you think is wrong
          </Typography>
        </Box>
        <Box width="100%">
          <Typography variant="subtitle1" align="left">
            New Data
          </Typography>
          <Box mt={1} />
          <Typography variant="body2" align="left" color="text.secondary">
            Information that you believe is more accurate
          </Typography>
        </Box>
      </Stack>
      <Stack
        direction="row"
        spacing={1}
        mt={2}
        alignItems="center"
        divider={
          <IconFeather
            icon={<ChevronsRight />}
            muiProps={{
              fontSize: 'medium',
              sx: { color: theme.palette.text.secondary },
            }}
          />
        }
      >
        <Box
          width="100%"
          height="100%"
          borderRadius={theme.shape.borderRadius / 2}
          p={2}
          bgcolor={alpha(theme.palette.primary.main, 0.07)}
        >
          <Stack direction="row" justifyContent="space-between" alignItems="center">
            <Typography variant="caption2" color="text.secondary">
              Full Name
            </Typography>
            <Typography variant="body2" color="text.primary">
              {renderTextOrDefault(dataContribution?.old_data_full_name)}
            </Typography>
          </Stack>
          <Stack direction="row" justifyContent="space-between" alignItems="center">
            <Typography variant="caption2" color="text.secondary">
              Title
            </Typography>
            <Typography variant="body2" color="text.primary">
              {renderTextOrDefault(dataContribution?.old_data_title)}
            </Typography>
          </Stack>
          <Stack direction="row" justifyContent="space-between" alignItems="center">
            <Typography variant="caption2" color="text.secondary">
              Email
            </Typography>
            <Typography variant="body2" color="text.primary">
              {renderTextOrDefault(dataContribution?.old_data_email)}
            </Typography>
          </Stack>
          <Stack direction="row" justifyContent="space-between" alignItems="center">
            <Typography variant="caption2" color="text.secondary">
              Phone Number
            </Typography>
            <Typography variant="body2" color="text.primary">
              {renderTextOrDefault(dataContribution?.old_data_phone_number)}
            </Typography>
          </Stack>
        </Box>
        <Box
          width="100%"
          height="100%"
          borderRadius={theme.shape.borderRadius / 2}
          p={2}
          bgcolor={alpha(theme.palette.primary.main, 0.07)}
        >
          <Stack direction="row" justifyContent="space-between" alignItems="center">
            <Typography variant="caption2" color="text.secondary">
              Full Name
            </Typography>
            <Typography variant="body2" color="text.primary">
              {renderTextOrDefault(dataContribution?.new_data_full_name)}
            </Typography>
          </Stack>
          <Stack direction="row" justifyContent="space-between" alignItems="center">
            <Typography variant="caption2" color="text.secondary">
              Title
            </Typography>
            <Typography variant="body2" color="text.primary">
              {renderTextOrDefault(dataContribution?.new_data_title)}
            </Typography>
          </Stack>
          <Stack direction="row" justifyContent="space-between" alignItems="center">
            <Typography variant="caption2" color="text.secondary">
              Email
            </Typography>
            <Typography variant="body2" color="text.primary">
              {renderTextOrDefault(dataContribution?.new_data_email)}
            </Typography>
          </Stack>
          <Stack direction="row" justifyContent="space-between" alignItems="center">
            <Typography variant="caption2" color="text.secondary">
              Phone Number
            </Typography>
            <Typography variant="body2" color="text.primary">
              {renderTextOrDefault(dataContribution?.new_data_phone_number)}
            </Typography>
          </Stack>
        </Box>
      </Stack>
    </Box>
  );
};

export default ReportWrongOtherContact;
